import React, { useEffect, useState } from "react";
import { Button, Form, Input, message, Modal, Space, Card, Popconfirm } from "antd";
import Table from "../../Reusable/Table/Table1";
import axios from "axios";
import consts from "../../constant";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import Loadingpage from "../Loadingpage/Loadingpage";
const HighlowSpreadSettings = () => {
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [spreads, setSpreads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchSettings = async () => {
    try {
      const { data } = await axios.post(`${consts.BackendUrl}/getTradeSettings`, { type: 'highLowSpread' }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      if (data?.success && data?.result?.highLowSpread) {
        setSpreads(data?.result?.highLowSpread);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const onFinish = async (values) => {
    if (spreads.length >= 5) {
      return messageApi.open({ type: "error", content: "Maximum 5 spread settings allowed" });
    }
    setLoading(true);
    try {
      await axios.post(`${consts.BackendUrl}/tradeSettings`, {
        type: 'highLowSpread',
        action: 'add',
        data: {
          duration: values.duration,
          winPercentage: Number(values.winPercentage),
        }
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "Spread setting added successfully" });
      form.resetFields();
      fetchSettings();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.message || "Failed to add setting"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setEditingId(record._id);
    editForm.setFieldsValue({
      duration: record.duration,
      winPercentage: record.winPercentage,
    });
    setIsEditModalOpen(true);
  };

  const onEditFinish = async (values) => {
    setLoading(true);
    try {
      await axios.post(`${consts.BackendUrl}/tradeSettings`, {
        type: 'highLowSpread',
        action: 'edit',
        id: editingId,
        data: {
          duration: values.duration,
          winPercentage: Number(values.winPercentage),
        }
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "Spread setting updated successfully" });
      setIsEditModalOpen(false);
      fetchSettings();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.message || "Failed to update setting"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.post(`${consts.BackendUrl}/deleteTradeSettings`, {
        type: 'highLowSpread',
        id
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "Spread setting deleted successfully" });
      fetchSettings();
    } catch (error) {
      messageApi.open({ type: "error", content: "Failed to delete setting" });
    }
  };

  const userColumns = [
    { title: "Duration", dataIndex: "duration", key: "duration" },
    {
      title: "Win Percentage",
      dataIndex: "winPercentage",
      key: "winPercentage",
      render: (val) => `${val}%`,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
          <Popconfirm
            title={<span style={{ color: "white" }}>Delete the setting</span>}
            description={
              <span style={{ color: "white" }}>
                Are you sure you want to delete this setting?
              </span>
            }
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
            overlayInnerStyle={{
              backgroundColor: "#03321E",
              border: "1px solid #2eff0c",
            }}


          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Loadingpage />
      {contextHolder}

      <div
        className="display-2 p-10"
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <h2> HighlowSpread Settings</h2>
      </div>
      <div
        className="card-clr"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          // height: "100%",
        }}
      >
        <Card
          style={{
            width: "100%",
            maxWidth: 500,
            padding: "30px 20px",
            marginBottom: "50px",
          }}
        >
          <Form
            form={form}
            name="spread_basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            labelAlign="left"
            style={{ maxWidth: 600 }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="Duration"
              name="duration"
              rules={[{ required: true }]}
            >
              <Input placeholder="Enter Duration" type="number" />
            </Form.Item>

            <Form.Item
              label="Win Percentage "
              name="winPercentage"
              rules={[{ required: true }]}
            >
              <Input
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="Win Percentage "
              />
            </Form.Item>

            <Form.Item style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type={spreads.length >= 5 ? "default" : "primary"}
                danger={spreads.length >= 5}
                disabled={spreads.length >= 5}
                htmlType="submit"
                loading={loading}
                style={
                  spreads.length >= 5
                    ? {
                      backgroundColor: "#ff4d4f",
                      borderColor: "#ff4d4f",
                      color: "#fff",
                    }
                    : {}
                }
              >
                {spreads.length >= 5 ? "Limit Reached (5)" : "Add"}
              </Button>
            </Form.Item>
          </Form>
          {/* {spreads.length >= 5 && (
          <div style={{ textAlign: 'center', color: '#ff4d4f', marginTop: '10px' }}>
            5 items can only added
          </div>
        )} */}
        </Card>
      </div>

      <div>
        <Table columnsConfig={userColumns} data={spreads} pagination={false} />
      </div>

      <Modal
        title="Edit Spread Setting"
        open={isEditModalOpen}
        onCancel={() => setIsEditModalOpen(false)}
        footer={null}
        maskStyle={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        styles={{
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          },
          header: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Form form={editForm} layout="vertical" onFinish={onEditFinish}>
          <Form.Item
            label="Duration"
            name="duration"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Win Percentage"
            name="winPercentage"
            rules={[{ required: true }]}
          >
            <Input
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default HighlowSpreadSettings;
